import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useOnScreen } from '@beef/utils';
import { debounce } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { getIsDecoupled } from "../window";
var EConstant = /*#__PURE__*/function (EConstant) {
  EConstant[EConstant["DefaultDebounceValue"] = 1000] = "DefaultDebounceValue";
  return EConstant;
}(EConstant || {});
/**
 * HOC, который передает аналитику при появлении компонента на экране
 */
export function withOnScreenAnalytics(onScreenAnalyticsHandler, extra) {
  return function (WrappedComponent) {
    return function (props) {
      var ref = useRef(null);
      var isInView = useOnScreen(ref);
      var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        hasTriggered = _useState2[0],
        setHasTriggered = _useState2[1];
      var debounceFn = useMemo(function () {
        return debounce(function () {
          setHasTriggered(true);
          return onScreenAnalyticsHandler.apply(void 0, arguments);
        }, (extra === null || extra === void 0 ? void 0 : extra.debounce) || Number(EConstant.DefaultDebounceValue));
      }, []);
      useEffect(function () {
        var isDecoupled = getIsDecoupled();
        var shouldTrigger = isInView && (!(extra !== null && extra !== void 0 && extra.shouldTriggerOnce) || !hasTriggered) || isDecoupled && !hasTriggered;
        if (shouldTrigger) {
          debounceFn(props);
        }
        if (!isInView && !isDecoupled) {
          var _debounceFn$cancel;
          debounceFn === null || debounceFn === void 0 || (_debounceFn$cancel = debounceFn.cancel) === null || _debounceFn$cancel === void 0 || _debounceFn$cancel.call(debounceFn);
        }
      }, [isInView, props, hasTriggered]);
      return /*#__PURE__*/React.createElement("div", {
        ref: ref,
        style: {
          display: 'flex',
          flexDirection: 'column',
          width: '100%'
        },
        "data-t-id": "utils-withOnScreenAnalytics"
      }, /*#__PURE__*/React.createElement(WrappedComponent, props));
    };
  };
}